import { useIntl } from 'react-intl';

import { useDiscountPricing } from '@/hooks/purchase/useDiscountPricing';
import { useFormattedPriceWithTax } from '@/hooks/purchase/useFormattedPriceWithTax';
import { usePricesState, usePurchaseParamsState } from '@/hooks/store';
import genericMessages from '@/messages/messages';
import { getPrice } from '@/store/purchaseParams/types';

import { Heading, Subheading } from '../styles';
import messages from './messages';

const LifetimeHeading = () => {
	const { formatMessage } = useIntl();
	const { discountHeading, discountSubheading } = useDiscountPricing();
	const prices = usePricesState();
	const { plan } = usePurchaseParamsState();
	const priceWithTax = useFormattedPriceWithTax(getPrice(plan, prices.current));

	return (
		<>
			<Heading>{discountHeading || formatMessage(genericMessages.purchaseTitleLifetime)}</Heading>
			<Subheading>
				{discountSubheading ||
					formatMessage(messages.genericLifetimeSubheading, {
						formattedPrice: priceWithTax,
					})}
			</Subheading>
		</>
	);
};

export default LifetimeHeading;
